import { ajax } from "../lib/observable";
import { Observable } from "rxjs";
import siteConfig from "site-config";
import { BUYER_SETUP_GUIDE } from "../constants/action-types";
import { trackChurnZeroEvent } from "lib/churn-zero";

export const fetchBuyerSetupGuideEpic = (action$) =>
    action$.ofType(BUYER_SETUP_GUIDE.FETCH.START).concatMap(() =>
        ajax({
            method: "GET",
            url: `${siteConfig.api}/user/setupguide`,
        })
            .flatMap(({ response }) => [{ payload: response, type: BUYER_SETUP_GUIDE.FETCH.SUCCESS }])
            .catch((error) => {
                trackChurnZeroEvent({
                    name: "merchant_dashboard.setup_guide.error",
                    customFields: { error: error.xhr?.response?.message || error.message },
                });
                return Observable.of({ error: true, payload: error, type: BUYER_SETUP_GUIDE.FETCH.ERROR });
            })
    );

export const dismissBuyerSetupGuideEpic = (action$) =>
    action$.ofType(BUYER_SETUP_GUIDE.DISMISS.START).concatMap(({ payload }) =>
        ajax({
            method: "PUT",
            url: `${siteConfig.api}/user/setupguide/dismiss`,
            body: { tasks: payload },
        })
            .flatMap(({ response }) => [
                { type: BUYER_SETUP_GUIDE.DISMISS.SUCCESS },
                { type: BUYER_SETUP_GUIDE.FETCH.START },
            ])
            .catch((error) => Observable.of({ error: true, payload: error, type: BUYER_SETUP_GUIDE.DISMISS.ERROR }))
    );
